import { serializeCsv } from "./csvParse";

/** Expansion import template — subsegment rows (parent WO + decimal suffix). */
export const EXPANSION_IMPORT_CSV_TEMPLATE_HEADERS = [
  "work_order",
  "segment",
  "project_name",
  "aecom_id",
  "customer",
  "status",
  "phase",
  "departments",
  "bid_out",
  "drafting_subphase",
  "permitting_subphase",
  "construction_subphase",
  "fiber_subphase",
  "accounting_subphase",
  "construction_footage",
  "override_footage",
  "caltrans_footage",
  "handholes",
  "drafter",
  "inspector",
  "construction_contractor",
  "fiber_contractor",
  "splicer",
];

const SAMPLE_ROWS = [
  {
    work_order: "6784.07",
    segment: "43",
    project_name: "SEG 43 UPRR Crossing",
    aecom_id: "07",
    customer: "CVIN Expansion",
    status: "Active",
    phase: "Construction",
    departments: "Engineering,Construction,Fiber,Networking,Accounting",
    bid_out: "false",
    drafting_subphase: "in_review",
    permitting_subphase: "application_submitted",
    construction_subphase: "scheduled",
    fiber_subphase: "ready_to_schedule",
    accounting_subphase: "ready_to_bill",
    construction_footage: "1250",
    override_footage: "",
    caltrans_footage: "200",
    handholes: "4",
    drafter: "",
    inspector: "",
    construction_contractor: "",
    fiber_contractor: "",
    splicer: "",
  },
  {
    work_order: "6784.08",
    segment: "43",
    project_name: "SEG 43 City of Example",
    aecom_id: "08",
    customer: "CVIN Expansion",
    status: "Active",
    phase: "Permitting",
    departments: "Engineering,Construction,Fiber,Networking,Accounting",
    bid_out: "false",
    drafting_subphase: "in_progress",
    permitting_subphase: "ready_to_submit",
    construction_subphase: "",
    fiber_subphase: "",
    accounting_subphase: "",
    construction_footage: "980",
    override_footage: "",
    caltrans_footage: "",
    handholes: "2",
    drafter: "Jane Doe",
    inspector: "",
    construction_contractor: "",
    fiber_contractor: "",
    splicer: "",
  },
];

export function buildExpansionImportCsvTemplate() {
  return serializeCsv(EXPANSION_IMPORT_CSV_TEMPLATE_HEADERS, SAMPLE_ROWS);
}

export function downloadExpansionImportCsvTemplate(filename = "expansion-import-template.csv") {
  const csv = buildExpansionImportCsvTemplate();
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
